import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import PreviewContent from "./PreviewContent";
import { MainModal } from "../../../components/modal/MainModal";
import { resetPreview, editModule, getEditPreview } from "../redux/customChartSagas";
import { useError } from "../hooks/useError";
import { ErrorList } from "../smartComponents/ErrorList";

export const Edit = ({ isOpen, onClose, selectedModule: { name, id } }) => {
  const dispatch = useDispatch();
  const close = () => {
    onClose();
    dispatch(resetPreview());
  };

  const { errors, status } = useError(close);
  const [currentName, setCurrentName] = useState(name);

  const save = () => {
    dispatch(editModule({ id, name: currentName }));
  };

  useEffect(() => {
    dispatch(getEditPreview(id, currentName));
  }, []);

  const onInputChange = (name) => {
    setCurrentName(name);
  };

  const primaryButtonDisabled = !(name && name.trim() && status !== "pending");

  return (
    <MainModal
      isOpen={isOpen}
      onClose={close}
      parentSelector=".custom-charts"
      headerText="Edit Custom Chart"
      headerCloseHandler={close}
      primaryBtnHandler={save}
      primaryButtonDisabled={primaryButtonDisabled}
      containerClassName="edit-chart light"
      primaryButtonText="Save"
      primaryButtonClass="primary-btn"
      secondaryBtnText="Cancel"
      secondaryBtnClass="secondary-btn"
      secondaryBtnHandler={close}
      height="auto"
      width={900}
    >
      <PreviewContent
        moduleId={id}
        name={currentName}
        onInputChange={(name) => onInputChange(name)}
      />
      {status === "pending" && (
        <div className="preview-loader">
          <LoadingAnimation uiLoader />
        </div>
      )}
      <ErrorList errors={errors} />
    </MainModal>
  );
};
